import { defineMessages } from 'react-intl';

export default defineMessages({
  upgradeFromViewerToStandardTitle: {
    id: 'app.features.licenseUpgrade.LicenseUpgradeModal.upgradeFromViewerToStandardTitle',
    defaultMessage: 'Unlock More with a Standard License',
  },
  viewerIntro: {
    id: 'app.features.licenseUpgrade.LicenseUpgradeModal.viewerIntro',
    defaultMessage:
      "You're on a Viewer license - you can explore everything, including read-only chat with the AI Companion. A Standard license lets you act on what you see:",
  },
  upgradeToStandard: {
    id: 'app.features.licenseUpgrade.LicenseUpgradeModal.upgradeToStandard',
    defaultMessage: 'Upgrade to a Standard license to get full access to:',
  },
  shapeStrategy: {
    id: 'app.features.licenseUpgrade.LicenseUpgradeModal.shapeStrategy',
    defaultMessage: 'Shape strategy',
  },
  trackKpisAndInitiatives: {
    id: 'app.features.licenseUpgrade.LicenseUpgradeModal.trackKpisAndInitiatives',
    defaultMessage: 'Track KPIs and {initiatives}',
  },
  draftAndOwnGoals: {
    id: 'app.features.licenseUpgrade.LicenseUpgradeModal.draftAndOwnGoals',
    defaultMessage: 'Draft and manage Goals and Key Results',
  },
  documentAchievements: {
    id: 'app.features.licenseUpgrade.LicenseUpgradeModal.documentAchievements',
    defaultMessage: 'Document achievements, learnings, and risks',
  },
  chatWithAiAgent: {
    id: 'app.features.licenseUpgrade.LicenseUpgradeModal.chatWithAiAgent',
    defaultMessage: 'Take action with the AI Companion',
  },
  collaborateAcrossTeams: {
    id: 'app.features.licenseUpgrade.LicenseUpgradeModal.collaborateAcrossTeams',
    defaultMessage: 'Collaborate across teams',
  },
  takeNextStep: {
    id: 'app.features.licenseUpgrade.LicenseUpgradeModal.takeNextStep',
    defaultMessage:
      'Upgrade to a Standard license to contribute, collaborate, and turn insights into action with the AI Companion.',
  },
  requestUpgrade: {
    id: 'app.features.licenseUpgrade.LicenseUpgradeModal.requestUpgrade',
    defaultMessage: 'Request Upgrade',
  },
  fallbackText: {
    id: 'app.features.licenseUpgrade.LicenseUpgradeModal.fallbackText',
    defaultMessage:
      'Need help upgrading? Contact your program lead or support@workpath.com.',
  },
  understood: {
    id: 'app.features.licenseUpgrade.LicenseUpgradeModal.understood',
    defaultMessage: 'Understood',
  },
  getStandardLicense: {
    id: 'app.features.licenseUpgrade.LicenseUpgradeModal.getStandardLicense',
    defaultMessage: 'Get Standard License',
  },
  upgrading: {
    id: 'app.features.licenseUpgrade.LicenseUpgradeModal.upgrading',
    defaultMessage: 'Upgrading...',
  },
  upgradeToStandardSuccess: {
    id: 'app.features.licenseUpgrade.LicenseUpgradeModal.upgradeToStandardSuccess',
    defaultMessage: 'Success! Your license has been upgraded to Standard.',
  },
  startContributing: {
    id: 'app.features.licenseUpgrade.LicenseUpgradeModal.startContributing',
    defaultMessage: 'Start Contributing',
  },
  selfServiceUpgradeInfo: {
    id: 'app.features.licenseUpgrade.LicenseUpgradeModal.selfServiceUpgradeInfo',
    defaultMessage:
      'Your organization allows you to upgrade from a Viewer to a Standard license on your own.',
  },
  upgradeToStandardError: {
    id: 'app.features.licenseUpgrade.LicenseUpgradeModal.upgradeToStandardError',
    defaultMessage: 'Failed to upgrade to Standard license. Please try again.',
  },
});
